const locale = {
  "inspections.accessibility":
    "Accessibility for people exposed to asbestos material",
  "inspections.amphibolesPresence":
    "Presence of amphiboles (crocidolite, amosite, tremolite, anthophyllite, and/or actinolite)",
  "inspections.asbestosVariety": "Asbestos variety",
  "inspections.between1150": "Between 11 and 50 linear and/or square meters",
  "inspections.between13": "From 1 to 3",
  "inspections.between2501000": "Rooms between 250 and 1000 cubic meters",
  "inspections.between410": "From 4 to 10",
  "inspections.difficultyAccessible":
    "Difficult to access in the daily use of the facility (low accessibility). Height above 2.2 meters. Occasional interaction with ACM possible.",
  "inspections.easyAccessible":
    "Easily accessible in the daily use of the facility (medium accessibility). Easy interaction with ACM possible.",
  "inspections.equipmentLocation": "Equipment or installation location",
  "inspections.extentQuantity": "Extent / quantity of asbestos material",
  "inspections.frequent":
    "The material is in a noisy and vibrating area (machine rooms). Frequent activities are performed that involve handling the material (more than once a month).",
  "inspections.friability": "Material friability",
  "inspections.greatDamage":
    "Severe damage or detachment of the layers that make up sprayed materials or 'flockings' and thermal insulations. Visible asbestos debris.",
  "inspections.highAccessible":
    "Accessible for any use (high accessibility). Height below 2.2 meters. Frequent interaction with ACM possible.",
  "inspections.highFriability":
    "Unencapsulated insulations and sprayed or 'flocked' materials. HIGH FRIABILITY material, fragments very easily just by touching it, possibly detaching.",
  "inspections.inaccessible": "Inaccessible in the daily use of the facility",
  "inspections.largeAndWellVentilated":
    "In large and well-ventilated spaces > 100 m3",
  "inspections.lessThan10": "Less than 10 linear and/or square meters",
  "inspections.lessThan250":
    "Spaces smaller than 250 cubic meters. Spaces that act as plenums in an air conditioning system regardless of size, or materials subjected to air currents.",
  "inspections.littleDamage":
    "Little damage: small scratches or marks, broken edges on boards, tiles, etc.",
  "inspections.lowFriability":
    "Sprayed or 'flocked' materials or sealed insulations; insulating boards (with the exposed face painted or encapsulated), asbestos cement, etc. LOW FRIABILITY material, can be damaged by hand, but with difficulty. The material may be damaged by impacts. The material has a cement base and leaves granules on the hand, but no dust. The material has partially lost its integrity.",
  "inspections.materialStatus":
    "Material condition (or possible deterioration)",
  "inspections.mediumDamage":
    "Medium damage: significant breakage of materials or large breaks in small areas where damaged materials may release fibers, visible water damage.",
  "inspections.mediumFriability":
    "Unencapsulated insulating boards or encapsulated insulations and sprayed or 'flocked' materials. MEDIUM FRIABILITY material, easy to fragment with simple hand pressure. Pieces can be removed simply by hand. The material has a cement base and leaves a powdery residue on the hands when rubbed.",
  "inspections.moreThan10": "More than 10",
  "inspections.moreThan51": "More than 51 square and/or linear meters",
  "inspections.never":
    "No activities are performed that involve handling or disturbing the material",
  "inspections.noDamage": "Good condition: no visible damage",
  "inspections.noFriability":
    "Reinforced compounds containing asbestos, reinforced plastics, resins, vinyls, etc. NON-FRIABLE material, hard and cannot be damaged by hand. An object is needed to damage it. The material is intact.",
  "inspections.none": "None",
  "inspections.occasionally":
    "Activities are performed that involve circulation through the area where asbestos material is located, or actions that involve handling the material very occasionally (less than once a month)",
  "inspections.occasionallyAccessible":
    "In closed spaces, occasionally accessible",
  "inspections.onlyChrysotile": "Only chrysotile",
  "inspections.outdoorOrEncapsulated": "Outdoor or fully encapsulated",
  "inspections.potentiallyExposed":
    "Number of potentially exposed people (including workers and users)",
  "inspections.smallQuantities":
    "Small quantities, 1 unit (gasket, rope, cord, plate, downpipe)",
  "inspections.technicalAccessibility": "Technical accessibility",
  "titularidad-privado": "PRIVATE",
  "titularidad-publico": "PUBLIC",
  "titularidad-todo": "ALL",
  "uso_del_edificio_Servicios Públicos": "Public services",
  address: "Address",
  amortization_graph: "Amortization graph",
  area: "Area",
  ASBESTOS_INVENTORY: "Asbestos inventory",
  asbestos_susceptibility: "Asbestos susceptibility",
  asbestos_type: "Asbestos type",
  asbestos: "Asbestos",
  asbestus_data: "Asbestus data",
  attachments: "Attachments",
  available_area: "Available area",
  available_trees: "Available trees",
  base_layer_selector: "Base layer",
  base_layer: "Base layer",
  biomass: "Biomass",
  building_age: "Building age",
  building_creation_date: "Building creation date",
  catastro_description:
    "Relevant information about buildings obtained directly from the cadastre.",
  catastro_title: "Cadastral",
  center_aoi: "Center AOI",
  center_user: "Center user",
  click_to_select_a_project: "My projects",
  co2: "CO₂",
  coming_soon: "Not available",
  common_name: "Common name",
  copying_element: "Copying element",
  creating_element: "Creating element",
  creating_new_element: "Creating new element",
  crown_diameter: "Crown diameter",
  current_use: "Current use",
  cyclosm_description:
    "Allows visualizing the terrain’s altitude and relief through contour lines, as well as natural elements (rivers, mountains, forests) and artificial ones (streets, roads, buildings).",
  cyclosm_title: "Topographic Map",
  dashboard: "Dashboard",
  delete_attachment_body:
    "Are you sure you want to delete this attachment? This action cannot be undone.",
  delete_attachment_title: "Delete attachment",
  delete_element_body:
    "Are you sure you want to delete this element? This action cannot be undone.",
  delete_element_title: "Delete element",
  delete_image: "Delete image",
  delete: "Delete",
  deleting_element: "Deleting element",
  deleting_image: "Deleting image",
  description: "Description",
  discard_changes_body:
    "You have unsaved changes. Do you want to discard them?",
  discard_changes_title: "Discard changes",
  discard: "Discard",
  district_b_code: "District B code",
  district_bar_code: "District bar code",
  district_code: "District code",
  district_name: "District name",
  district_tx: "District TX",
  edification_data: "Edification data",
  EDIFICATION_INVENTORY: "Edification inventory",
  edification: "Edification",
  edit_feature: "Edit feature",
  edit: "Edit",
  element_copied_successfully: "Element copied successfully",
  element_copying_error: "Error copying element",
  element_created_successfully: "Element created successfully",
  element_creating_error: "Error creating element",
  element_deleted_successfully: "Element deleted successfully",
  element_type: "Element type",
  energy_graph: "Energy graph",
  exit_edition: "Exit photointerpretation",
  filters: "Filters",
  form: "Form",
  fx_creation: "Creation date",
  fx_modification: "Modification date",
  google_satellite_description:
    "From Google's services. In certain regions, it provides more up-to-date images and higher resolution than those provided by IGN.",
  google_satellite_title: "Google",
  has_lab_measures: "Has lab measures",
  header_category: "Category",
  header_description: "Description",
  header_image: "Image",
  header_tag: "Tags",
  header_title: "Title",
  height: "Height",
  image_deleted_successfully: "Image deleted successfully",
  image_uploaded_successfully: "Image uploaded successfully",
  images: "Images",
  ine_code: "INE code",
  info: "Information",
  inspection_type: "Inspection type",
  is_asbestos: "Contains asbestos",
  lab_measure_note: "Lab measure note",
  lab_measure_ref_code: "Lab measure reference code",
  layer_attributions: "Layer attributions",
  layer_groups: "Layer groups",
  layer_visualization_control: "Layer visualization control",
  layers: "Layers",
  leaf_type: "Leaf type",
  legend: "Legend",
  less: "Less",
  link_catastro: "Link to cadastre",
  link_maps: "Link to maps",
  link: "Link",
  loading_data: "Loading data",
  loading_legend: "Loading legend",
  loading_map: "Loading map",
  log_out: "Log out",
  m2_catastro: "Cadastral",
  made_by: "Made by",
  main_species: "Main species",
  major_neighborhood: "Major neighborhood",
  more: "More",
  municipality: "Municipality",
  n_elements_inside: "Number of elements",
  n_ref_catastral: "Cadastral reference number",
  name: "Name",
  neighborhood_code: "Neighborhood code",
  neighborhood_mt: "Neighborhood MT",
  neighborhood_name: "Neighborhood name",
  neighborhood_number: "Neighborhood number",
  no_attributions: "No attributions",
  no_changes_made: "No changes to save",
  no_info_to_display: "Empty location",
  no: "No",
  obtaining_data: "Obtaining data",
  open_in_new_tab: "Open in new tab",
  osm_description:
    "Map based on Open Street Map that allows visualizing street names and points of interest buildings.",
  osm_title: "Street Map",
  owner: "Owner",
  pa: "Depth",
  percent: "Percent",
  pnoa_description:
    "This base map uses the WMTS provided by the PNOA for a clear visualization of high-resolution photographs of the terrain.",
  pnoa_title: "Aerial",
  prev_state: "Previous state",
  print: "Print",
  prop_state: "Proposed state",
  province: "Province",
  questionsPhase1: "Environment",
  questionsPhase2: "Material",
  questionsPhase3: "Sum of factor values",
  read_only: "read only",
  risk_final_value: "Risk final value",
  risk_form_value: "Risk form value",
  risk_simplify_type: "Risk simplification type",
  risk_type_used: "Risk type used",
  save_changes_body: "Do you want to save the changes before leaving?",
  save_changes_title: "Save changes",
  save: "Save",
  season: "Season",
  select_project: "Select a project",
  selected_point: "Selected point",
  selection_details: "Selection details",
  shape_length: "Shape length",
  show_layer_attributions: "Show layer attributions",
  show_more: "Show more",
  simple: "Simple",
  solar_data: "Solar data",
  species_count: "Species count",
  species: "Species",
  status: "Status",
  susceptibility_label_alta: "High",
  susceptibility_label_baja: "Low",
  susceptibility_label_media: "Medium",
  susceptibility_label_muy_alta: "Very high",
  susceptibility_title:
    "Minimum susceptibility to contain asbestos represented",
  table: "Table",
  title: "Title",
  titularidad: "Ownership",
  to: "To",
  toggle_visibility: "Toggle visibility",
  tooltipTeledeteccion: "Photointerpretation",
  trees: "Trees",
  txt_description_title_information:
    "In this tool, you can obtain a quote for asbestos remote sensing services for municipalities, as well as analyses that will help you understand and provide relevant information for your client.",
  txt_description_title:
    "Census of facilities with the presence of asbestos in municipalities, mandatory according to Law 07/2022",
  txt_description:
    "Municipalities are required to conduct a census of facilities and sites containing asbestos, including a schedule for its removal, according to Law 07/2022, dated April 8, on waste and contaminated soils for a circular economy. Comply with Law 07/2022 easily with our solution.\nAgforest provides the complete solution for your asbestos facility census, using artificial intelligence algorithms and satellite imagery to detect asbestos in your locality.",
  txt_footer_legal: "Legal notice",
  txt_footer_privacity: "Privacy policy and cookies",
  type: "Type",
  undo: "Undo",
  uploading_image: "Uploading image",
  usage: "Usage",
  uso_del_edificio_Agrícola: "Agricultural",
  uso_del_edificio_Industrial: "Industrial",
  uso_del_edificio_Oficinas: "Offices",
  uso_del_edificio_Otros: "Others",
  uso_del_edificio_Residencial: "Residential",
  uso_del_edificio_Retail: "Retail",
  uso_del_edificio: "Building use",
  visibility: "Opacity",
  visualization_selector: "Visualization",
  visualization: "Visualization",
  website: "Website",
  write_an_address: "Write an address",
  years: "Years",
  yes: "Yes",
  zonas_catastro_description:
    "This map combines two layers of information: built-up zones obtained from the cadastre and aerial photographs of the region.",
  zonas_catastro_title: "Aerial + Cadastral",
  zoom_in: "Zoom in",
  zoom_out: "Zoom out",
  MCA: "MCA - Contains asbestos",
  MPCA: "MPCA - Possible asbestos",
  NOMCA: "NOMCA - Without asbestos",
  PRELIMINAR: "Preliminary",
  BASICO: "Basic",
  DETALLADO: "Detailed",
  CRISOTILO: "Chrysotile",
  ASBESTOS: "Asbestos",
  CUBIERTA: "Roof",
  PARAMENTO: "Wall",
  material: "Material",

  adhesives_cements_sealants: "Adhesives, cements, sealants",
  adhesives: "Adhesives",
  adhesive_cement: "Adhesive cement",
  caulking: "Caulking",
  cement: "Cement",
  duct_adhesive: "Duct adhesive",
  finishing_cement: "Finishing cement",
  furnace_cement: "Furnace cement",
  insulating_cement: "Insulating cement",
  joint_cement: "Joint cement",
  masonry_cement: "Masonry cement",
  putties: "Putties",
  mortar: "Mortar",
  plastic_cement: "Plastic cement",
  sealant: "Sealant",

  asbestos_paper_board_roll: "Asbestos paper, board roll, board",
  asbestos_paper: "Asbestos paper",
  corrugated_paper: "Corrugated paper",
  flexible_board: "Flexible board",
  millboard: "Millboard",
  permanent_board: "Permanent board",
  roll: "Roll",
  vinyl_wallpaper: "Vinyl wallpaper",

  automotive_materials_friction: "Automotive materials, friction",
  brake_linings: "Brake linings",
  brake_pads: "Brake pads",
  brakes: "Brakes",
  clutch_linings: "Clutch linings",
  disc_brakes: "Disc brakes",
  drum_brakes: "Drum brakes",
  elevator_brake_shoes: "Elevator brake shoes",
  transmission_plates: "Transmission plates",

  cement_pipes_boards_sheets_plastics: "Cement pipes, boards, sheets, plastics",
  asbestos_board: "Asbestos board",
  asbestos_sheets: "Asbestos sheets",
  cement_pipes: "Cement pipes",
  plastics: "Plastics",
  stone_coating: "Stone coating",

  clay_compounds_paints_plasters: "Clay, compounds, paints, plasters",
  acoustic_plaster: "Acoustic plaster",
  asphalt: "Asphalt",
  filler: "Filler",
  finishing: "Finishing",
  joint_compound: "Joint compound",
  paint: "Paint",
  patching: "Patching",
  plaster: "Plaster",
  putty: "Putty",
  putty_compounds: "Putty compounds",

  electrical_mechanical_products: "Electrical and mechanical products",
  boilers: "Boilers",
  cables_wires: "Cables and wires",
  electrical_boards: "Electrical boards",
  furnaces: "Furnaces",
  generators: "Generators",
  heating_ducts: "Heating ducts",
  pumps: "Pumps",
  turbines: "Turbines",
  valve_rings: "Valve rings",
  valves: "Valves",
  weather_resistant_jackets: "Weather-resistant jackets",
  wiring_insulation: "Wiring insulation",

  flooring_tiles: "Flooring, tiles",
  ceiling_tiles: "Ceiling tiles",
  tiles: "Tiles",
  flooring: "Flooring",
  slabs: "Slabs",
  vinyl_linoleum_floors: "Vinyl and linoleum floors",
  wall_tiles: "Wall tiles",

  gaskets_packings_sealing_materials: "Gaskets, packings, sealing materials",
  braided_packing: "Braided packing",
  gasket_material: "Gasket material",
  gaskets: "Gaskets",
  packing_material: "Packing material",
  rope_packing: "Rope packing",
  sheet_packing: "Sheet packing",

  household_products: "Household products",
  agricultural_filler: "Agricultural filler",
  attic_insulation: "Attic insulation",
  cigarette_filters: "Cigarette filters",
  clay_pots: "Clay pots",
  fertilizer: "Fertilizer",
  exhaust_hoods: "Exhaust hoods",
  iron_stands: "Iron stands",
  ironing_board_covers: "Ironing board covers",
  lab_hoods: "Lab hoods",
  potting_mixes: "Potting mixes",
  stove_mats: "Stove mats",

  panels_drywall_wall_coverings: "Panels, drywall, wall coverings",
  acoustic_panels: "Acoustic panels",
  drywall: "Drywall",
  marine_panel: "Marine panel",
  panels: "Panels",
  gypsum_board: "Gypsum board",
  wallboard: "Wallboard",

  pipe_covering_block: "Pipe covering and block",
  block_insulation: "Block insulation",
  calcium_silicate: "Calcium silicate",
  duct_insulation: "Duct insulation",
  insulation: "Insulation",
  magnesia: "Magnesia",
  pipe_insulation: "Pipe insulation",
  preformed_pipe_wrap: "Preformed pipe wrap",
  sponge_block: "Sponge block",
  sleeveless_jacket: "Sleeveless jacket",

  protective_clothing: "Protective clothing",
  aprons: "Aprons",
  asbestos_helmet: "Asbestos helmet",
  dust_masks: "Dust masks",
  glassblowers_mittens: "Glassblowers' mittens",
  gloves: "Gloves",
  lab_gloves: "Lab gloves",
  mittens: "Mittens",
  respirators: "Respirators",
  sleeves: "Sleeves",
  textile_garments: "Textile garments",

  protective_fireproof_coatings: "Protective and fireproof coatings",
  asbestos_curtains: "Asbestos curtains",
  asbestos_spray: "Asbestos spray",
  boiler_coating: "Boiler coating",
  fireproof_blankets: "Fireproof blankets",
  fire_dampers: "Fire dampers",
  fire_doors: "Fire doors",
  fireproof_cement: "Fireproof cement",
  fireproof_materials: "Fireproof materials",
  insulating_coating: "Insulating coating",
  roof_coating: "Roof coating",
  textured_coatings: "Textured coatings",
  coating: "Coating",

  raw_asbestos: "Raw asbestos",
  asbestos_fiber: "Asbestos fiber",
  fake_snow: "Fake snow",
  raw_asbestos: "Raw asbestos",
  calsilite_silicate: "Calsilite silicate",
  talc_powder: "Talc powder",
  transite: "Transite",
  vermiculite: "Vermiculite",

  refractory_products: "Refractory products",
  castables: "Castables",
  refractory_brick: "Refractory brick",
  marinite: "Marinite",
  refractory_cement: "Refractory cement",
  refractory_products: "Refractory products",

  rope_wick_cord_tape_cork: "Rope, wick, cord, tape, cork",
  asbestos_cord: "Asbestos cord",
  asbestos_rope: "Asbestos rope",
  cork_coating: "Cork coating",
  foil_rope: "Foil rope",
  tape: "Tape",
  wicking: "Wicking",

  textiles_felts_fabrics: "Textiles, felts, fabrics",
  asbestos_blanket: "Asbestos blanket",
  asbestos_canvas: "Asbestos canvas",
  asbestos_fabric: "Asbestos fabric",
  asbestos_felt: "Asbestos felt",
  asbestos_lap: "Asbestos lap",
  asbestos_wool: "Asbestos wool",
  asbestos_thread: "Asbestos thread",
  lagging: "Lagging",
  roving: "Roving",
  textiles: "Textiles",

  element_updated_successfully: "Element updated successfully",
  updating_element: "Updating element",
  link_to_google_maps: "Link to Google Maps",
  link_to_google_earth: "Link to Google Earth",
  PENDING: "Pending",
  IN_REVIEW: "In review",
  REVIEWED: "Reviewed",
  CLEAR: "Clear",
  change_grid_status: "Change grid status to...",
  changing_grid_status: "Changing grid status",
  grid_status_changed_successfully: "Grid status changed successfully",
  BAJANTE: "Downpipe",
  LAB_MEASURES: "Lab measures",
  no_images: "No images",
  expand_image: "Expand image",
  "Muy Alto": "Very high",
  Alto: "High",
  Medio: "Medium",
  Bajo: "Low",
  Industrial: "Industrial",
  Residencial: "Residential",
  Oficinas: "Offices",
  Agrícola: "Agricultural",
  Retail: "Retail",
  "Servicios Públicos": "Public Services",
  Otros: "Others",
  Privado: "Private",
  Público: "Public",
  Municipal: "Municipal",
  fx_pending: "Pending date",
  fx_clear: "Clear date",
  fx_review: "Review date",
  link_to: "Link to...",
  ASBESTOS_SUSCEPTIBILIDAD: "Asbestos susceptibility",
  building_refurbishing_date: "Building refurbishing date",
  cannot_display_image: "Cannot display image",
  close_image: "Close image",
  no_grid_to_update: "No grid to update",
  download_image: "Download image",
  save_geometry: "Save geometry",
  save_geometry_title: "Save geometry",
  save_geometry_body: "Are you sure you want to save the geometry?",
  tags: "Tags",
  aois: "AOIs",
  show_info: "Show info",
  features: "Features",
  create_inventory_element: "Create inventory element...",
  point: "Point",
  polygon: "Polygon",
  invalid_geometry: "Invalid geometry",
  add_new_feature: "Add new feature",
  IN_PROGRESS: "In progress",
  tooltipChangeGrid: "Regenerate grid",
  from_layer: "From layer",
  small: "Small",
  medium: "Medium",
  large: "Large",
  select_layer: "Select a layer",
  size: "Size",
  name_en: "English name",
  name_es: "Spanish name",
  regenerating_grid: "Regenerating grid",
  grid_regenerated_successfully: "Grid regenerated successfully",
  reset_rotation: "Reset rotation",
  "Sin datos": "Actual",
  "Cobertura arbórea": "Tree cover",
  Matorral: "Shrubland",
  Pastizales: "Grasslands",
  "Tierras de cultivo": "Croplands",
  "Área urbanizada": "Urban area",
  "Vegetación escasa o desnuda": "Sparse vegetation or bare land",
  "Cuerpos de agua permanentes": "Permanent water bodies",
  "Humedales herbáceos": "Herbaceous wetlands",
  Manglares: "Mangroves",
  "Musgos y líquenes": "Mosses and lichens",

  category: "Category",
  area_properties: "Area properties",
  actual_ground_use_distribution: "Actual ground use distribution",
  market_value: "Market value",
  area_km2: "Area",
  market_value_euros: "Total value",
  market_value_euros_per_km2: "Market value",
  carbon_Mg: "Carbon",
  carbon_Mg_per_km2: "Carbon",
  biomass_Mg: "Biomass",
  biomass_Mg_per_km2: "Biomass",
  biomass_tonnes: "Biomass",
  biomass_tonnes_per_km2: "Biomass",
  carbon_kg: "Carbon",
  carbon_kg_per_km2: "Carbon",
  biomass_kg: "Biomass",
  biomass_kg_per_km2: "Biomass",
  carbon_credits_tCO2e: "Carbon credits",
  carbon_credits_tCO2e_per_km2: "Carbon credits",
  // area_km2: "Area (km²)",
  // market_value_euros: "Market value (€)",
  // market_value_euros_per_km2: "Market value (€ / km²)",
  // carbon_Mg: "Carbon (Mg)",
  // carbon_Mg_per_km2: "Carbon (Mg / km²)",
  // biomass_Mg: "Biomass (Mg)",
  // biomass_Mg_per_km2: "Biomass (Mg / km²)",
  // biomass_tonnes: "Biomass (tonnes)",
  // biomass_tonnes_per_km2: "Biomass (tonnes / km²)",
  // carbon_kg: "Carbon (kg)",
  // carbon_kg_per_km2: "Carbon (kg / km²)",
  // biomass_kg: "Biomass (kg)",
  // biomass_kg_per_km2: "Biomass (kg / km²)",
  // carbon_credits_tCO2e: "Carbon credits (tCO2e)",
  // carbon_credits_tCO2e_per_km2: "Carbon credits (tCO2e / km²)",
  carbon_credits: "Carbon credits",
  copy: "Copy",
  copied: "Copied!",
  geometry_error: "Invalid geometry",
  market_value_euros_per_m2: "Value per area",
  expand: "Expand",
  contract: "Contract",
  unavailable: "Unavailable",
  data_filter_control: "Data filter control",

  // TUTORIAL
  next: "Next",
  back: "Back",
  last: "Finish",
  skip: "Skip",
  of: "of",
  tutorial_step_title_1: "Welcome to the Agforest viewer",
  tutorial_step_body_1:
    "In the following tutorial, we will show you the functionalities of the website.",
  tutorial_step_body_2: "Controls over the map viewer",
  tutorial_step_body_3: "Options from the side menu",
  tutorial_sidebar_button: "Here are your projects and the layer options.",
  tutorial_user_directions_button: "Address search and user options.",
  tutorial_map_controls_button: "Basic map controls.",
  tutorial_attributions_button: "Layer attributions.",
  tutorial_step_title_4: "Tutorial completed",
  tutorial_step_body_4: "Enjoy your experience in Agforest! 😃😃",
  tutorial_my_projects_button:
    'If you click on "My Projects", you will see all your subscribed projects.',
  tutorial_layers:
    "Layer groups, which in turn contain individual layers, have actions you can perform on each one.",
  tutorial_tabs:
    "Switch tabs to access filters or control panels, if available.",
  finish: "Finish",
  previous: "Previous",
  select_language: "Select language",
  tutorial_carbon_body_1:
    "First, select the area of the map you want to analyze.",
  tutorial_carbon_title: "Carbon Study",
  tutorial_carbon_body_2:
    "In this window you will see the summary of the carbon study, where you can perform tests.",
  tutorial_carbon_category:
    "Change category to view new properties of the selected area",
  show_tutorial: "Show tutorial",
  tutorial_repeat: "Click here to start the tutorial again",
  carbon_quotes_graph_title: "Daily evolution of carbon credit (CC) prices",
  actual_carbon_quote: "Actual CC Value",
  carbon_quote: "CC Value",
  download_geojson: "Download GeoJSON",
  downloading_geojson: "Downloading GeoJSON",
  geojson_downloaded_successfully: "GeoJSON downloaded successfully",
  geojson_downloading_error: "Error downloading GeoJSON",
  layer_description: "Layer description",
  updating_asbestos_presence:
    "Updating asbestos presence in the selected element",
  asbestos_presence_updated_successfully:
    "Asbestos presence updated successfully to",
  asbestos_presence_update_error: "Error updating asbestos presence",
  no_element_found: "No element found",
  restore_asbestos_presence_title: "Restore asbestos presence",
  restore_asbestos_presence_body:
    "Are you sure you want to restore the asbestos presence of this element?",
  restoring_asbestos_presence: "Restoring asbestos presence",
  asbestos_presence_restored_successfully:
    "Asbestos presence restored successfully to",
  change_asbestos_presence: "Change asbestos presence to...",
  open_settings: "Open settings",
  settings: "Settings",
  toggle_snap_guides: "Draw guides",
  exit_draw_polygon_mode: "Finish drawing",

  accumulated_carbon_credits: "Accumulated carbon credits",
  co2_absoption_evolution: "CO₂ absorption evolution",
  "relation_tCO2/pie_tCO2/km2": "Relation tCO₂/tree - tCO₂/km²",
  accumulated_credits_by_class: "Accumulated credits by class",
  carbon_credits_per_class: "Carbon credits per class",
  class: "Class",
  select_classes: "Select classes",
  year: "Year",
  accumulated_absorption_tCO2_km2: "Accumulated absorption (tCO₂/km²)",
  accumulated_absorption_tCO2_ha: "Accumulated absorption (tCO₂/ha)",
  accumulated_absorption_tCO2_tree: "Accumulated absorption (tCO₂/tree)",
  constant_scenario: "Constant scenario",
  optimistic_scenario: "Optimistic scenario",
  pessimistic_scenario: "Pessimistic scenario",
  constante_scenario: "Constant scenario",
  optimista_scenario: "Optimistic scenario",
  pesimista_scenario: "Pessimistic scenario",
  select_scenario: "Select scenario",

  // Especies Portugal
  "Agricultura com espaços naturais e seminaturais":
    "Agriculture with natural and semi-natural areas",
  "Agricultura protegida e viveiros": "Protected agriculture and nurseries",
  "Albufeiras de barragens": "Reservoirs of dams",
  "Áreas em construção": "Construction areas",
  Aterros: "Landfills",
  Comércio: "Commerce",
  "Culturas temporárias de sequeiro e regadio":
    "Temporary irrigated and rainfed crops",
  "Cursos de água naturais": "Natural watercourses",
  "Equipamentos culturais": "Cultural facilities",
  "Equipamentos de lazer": "Leisure facilities",
  "Florestas de castanheiro": "Chestnut forests",
  "Florestas de espécies invasoras": "Invasive species forests",
  "Florestas de eucalipto": "Eucalyptus forests",
  "Florestas de outras folhosas": "Other broadleaved forests",
  "Florestas de outras resinosas": "Other coniferous forests",
  "Florestas de outros carvalhos": "Other oak forests",
  "Florestas de pinheiro bravo": "Maritime pine forests",
  "Florestas de sobreiro": "Cork oak forests",
  Indústria: "Industry",
  "Infraestruturas de produção de energia renovável":
    "Renewable energy production infrastructures",
  "Infraestruturas de tratamento de resíduos e águas residuais":
    "Waste and wastewater treatment infrastructures",
  "Infraestruturas para captação, tratamento e abastecimento de águas para consumo":
    "Water abstraction, treatment and supply infrastructures",
  "Instalações agrícolas": "Agricultural facilities",
  "Instalações desportivas": "Sports facilities",
  "Lixeiras e Sucatas": "Landfills and scrap yards",
  Matos: "Scrublands",
  "Mosaicos culturais e parcelares complexos":
    "Complex cultural and parcel mosaics",
  Olivais: "Olive groves",
  "Outros equipamentos e instalações turísticas":
    "Other tourist facilities and infrastructures",
  "Parques e jardins": "Parks and gardens",
  "Pastagens espontâneas": "Spontaneous pastures",
  "Pastagens melhoradas": "Improved pastures",
  Pedreiras: "Quarries",
  Pomares: "Orchards",
  "Rede viária e espaços associados": "Road network and associated areas",
  "Tecido edificado contínuo predominantemente horizontal":
    "Continuous predominantly horizontal built-up fabric",
  "Tecido edificado contínuo predominantemente vertical":
    "Continuous predominantly vertical built-up fabric",
  "Tecido edificado descontínuo": "Discontinuous built-up fabric",
  "Tecido edificado descontínuo esparso":
    "Sparse discontinuous built-up fabric",
  "Vegetação esparsa": "Sparse vegetation",
  Vinhas: "Vineyards",

  absorption_evolution_per_class: "Absorption evolution per class",
  accumulated_carbon_by_class: "Accumulated carbon by class",
  carbon_credit_projection_full_area: "Carbon credit projection (full area)",
  accumulated_credits_per_km2: "Accumulated credits per km²",
  vegetation_state_distribution: "Vegetation state distribution",

  // Especies España
  "Abedul pubescens (Betula alba)": "Downy birch (Betula alba)",
  "Acebo (Ilex aquifolium)": "Holly (Ilex aquifolium)",
  "Agrícola con arbolado": "Agricultural land with trees",
  "Aliso (Alnus glutinosa)": "Alder (Alnus glutinosa)",
  Arbolado: "Woodland",
  "Arce seudoplátano (Acer pseudoplatanus)":
    "Sycamore maple (Acer pseudoplatanus)",
  "Avellano (Corylus avellana)": "Hazel (Corylus avellana)",
  "Balsas y estanques": "Ponds and pools",
  "Bardaguera (Salix atrocinerea)": "Grey willow (Salix atrocinerea)",
  "Caminos y sendas": "Paths and tracks",
  Carreteras: "Roads",
  "Castaño (Castanea sativa)": "Chestnut (Castanea sativa)",
  "Coberturas de agua": "Water surfaces",
  "Construcción deportiva": "Sports construction",
  Coníferas: "Conifers",
  "Coníferas genéricas": "Generic conifers",
  Cultivos: "Crops",
  "Cultivos herbáceos": "Herbaceous crops",
  "Cursos de agua": "Watercourses",
  Desconocido: "Unknown",
  Edificación: "Buildings",
  Embalses: "Reservoirs",
  "Eucalipto globulus (Eucalyptus globulus)": "Blue gum (Eucalyptus globulus)",
  "Eucalipto nitens (Eucalyptus nitens)": "Shining gum (Eucalyptus nitens)",
  "Fresno excelsior (Fraxinus excelsior)": "Ash (Fraxinus excelsior)",
  "Frondosas caducifolias": "Deciduous broadleaves",
  "Frondosas genéricas": "Generic broadleaves",
  "Frondosas perennifolias": "Evergreen broadleaves",
  "Frutales no cítricos": "Non-citrus fruit trees",
  "Haya (Fagus sylvatica)": "Beech (Fagus sylvatica)",
  Huerta: "Orchard garden",
  "Madroño (Arbutus unedo )": "Strawberry tree (Arbutus unedo)",
  Matorral: "Shrubland",
  "Otras construcciones": "Other constructions",
  Pastizal: "Grassland",
  "Pastizal-matorral": "Shrub-grassland",
  "Pasto arbolado": "Wooded pasture",
  "Peral silvestre (Pyrus spp.": "Wild pear (Pyrus spp.)",
  "Pino pináster (Pinus pinaster)": "Maritime pine (Pinus pinaster)",
  "Pino radiata (Pinus radiata)": "Monterey pine (Pinus radiata)",
  "Pino silvestre (Pinus sylvestris)": "Scots pine (Pinus sylvestris)",
  Piscina: "Swimming pool",
  Prados: "Meadows",
  "Rebollo (Quercus pyrenaica)": "Pyrenean oak (Quercus pyrenaica)",
  "Red de transporte terrestre sin catalogar":
    "Unclassified land transport network",
  "Roble (Quercus petraea)": "Sessile oak (Quercus petraea)",
  "Roble pedunculado (Quercus robur)": "Pedunculate oak (Quercus robur)",
  "Serbal de cazadores (Sorbus aucuparia)": "Rowan (Sorbus aucuparia)",
  "Seudotsuga (Pseudotsuga menziesii)": "Douglas fir (Pseudotsuga menziesii)",
  "Suelo no edificado": "Unbuilt land",
  "Terrenos con escasa o nula vegetación": "Bare or sparsely vegetated land",
  Viñedo: "Vineyard",
  "Vías urbanas": "Urban roads",
  "Zona abierta": "Open area",
  "Zona verde artificial y arbolado urbano":
    "Artificial green area and urban trees",
  "Zonas de extracción": "Extraction areas",
  "Zonas de vertido": "Dumping areas",
  "Zonas pavimentadas o selladas": "Paved or sealed areas",
  scenario: "Scenario",
  total_area_ha: "Total area (ha)",
  downloading_all_attached_files: "Downloading all attached files",
  all_attached_files_downloaded_successfully:
    "All attached files downloaded successfully",
  download_all_attachments_error: "Error downloading all attached files",
  download_all_attachments: "Download all attachments",
  location_unavailable: "Location unavailable",

  // Solar fields - from asbestos census with solar integration
  SolEnergia: "Estimated annual energy",
  SolCO2: "Tons of CO₂ avoided annually",
  SolAhorro: "Estimated annual savings",
  SolAreaPnl: "Photovoltaic panel area",
  SolHRA: "Annual horizontal irradiation",
  SolHRM: "Mean horizontal irradiation",
  SolTA: "Annual temperature",
  SolTM: "Mean temperature",
  SolRDNA: "Annual direct normal irradiation",
  SolRDNM: "Mean direct normal irradiation",
  SolRAOA: "Annual optimal angle irradiation",
  SolRAOM: "Mean optimal angle irradiation",
  Potencia_instalada_kWp: "Installed power",
  N_modulos: "Number of modules to install",
  Potencia_modulos: "Power per module",
  Ratio_kWp_m2: "Power / area ratio",
  "Coste_€_kWp": "Cost per kWp",
  Superficie_cubierta: "Roof surface",
  Superficie_fv_percent: "Photovoltaic surface percentage",
  Lucernario: "Skylight",
};
export default locale;
